import React from 'react';

export const DataGrid = ({ columns, data, onRowClick, selectedRow, actionButtons }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-slate-200 h-full flex flex-col">
      <div className="flex-1 overflow-auto">
        <table className="divide-y divide-slate-200" style={{ minWidth: 'max-content', width: '100%' }}>
        <thead className="bg-slate-50 sticky top-0 z-10">
          <tr>
            {columns.map((col, idx) => (
              <th
                key={idx}
                className="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider bg-slate-50"
                style={col.headerStyle || {}}
              >
                {col.header}
              </th>
            ))}
            {actionButtons && (
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider bg-slate-50">
                操作
              </th>
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-100">
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length + (actionButtons ? 1 : 0)} className="px-4 py-8 text-center text-slate-500">
                データがありません
              </td>
            </tr>
          ) : (
            data.map((row, rowIdx) => (
              <tr
                key={rowIdx}
                onClick={() => onRowClick && onRowClick(row)}
                className={`transition-colors ${
                  onRowClick ? 'cursor-pointer' : ''
                } ${
                  selectedRow && JSON.stringify(selectedRow) === JSON.stringify(row)
                    ? 'bg-slate-100'
                    : 'hover:bg-slate-50'
                }`}
              >
                {columns.map((col, colIdx) => (
                  <td key={colIdx} className="px-4 py-3 whitespace-nowrap text-sm text-slate-900">
                    {col.render ? col.render(row, rowIdx) : row[col.field]}
                  </td>
                ))}
                {actionButtons && (
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-900">
                    {actionButtons(row, rowIdx)}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};
